// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'
import { COLORS } from '~theme/colors'

export const CopyClipboardSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path
        d="M20.343 12.271a1.451 1.451 0 001.282-1.654l-.049-.34L6.183 12.02l.258 1.825 13.902-1.574z"
        fill="#fff"
        stroke={COLORS.secondary.darkBlue}
      />
      <path
        d="M14.946 5.156a1.452 1.452 0 011.946-.771l.314.14-5.979 14.356-1.683-.755 5.402-12.97zM6.197 14.167c-1.192.906-2.941.656-3.9-.606-.96-1.261-.734-3.014.459-3.92 1.192-.907 2.941-.657 3.9.605.96 1.261.734 3.014-.459 3.92z"
        fill="#fff"
        stroke={COLORS.secondary.darkBlue}
      />
      <path
        d="M12.557 22.53c-1.193.907-2.942.657-3.902-.605-.959-1.262-.732-3.014.46-3.921s2.942-.657 3.901.605c.96 1.262.733 3.014-.46 3.921z"
        fill="#fff"
        stroke={COLORS.secondary.darkBlue}
      />
      <path
        d="M8.161 12.302l.111.833L6 13.5l.051-.976 2.11-.222z"
        fill="#fff"
      />
      <path
        d="M7.44 18.198a1.452 1.452 0 011.958-.74l.368.173-1.355 3.11-1.726-.808.756-1.735z"
        fill="#fff"
        stroke={COLORS.secondary.darkBlue}
      />
      <path
        fill="#fff"
        d="M10.868 16.242l.771.345-.812 1.958-.77-.344zM8.185 14.538l1.946.873-3.649 8.762-1.946-.873z"
      />
      <path
        d="M6.502 15.326a1.51 1.51 0 001.352-1.584l-4.403.448.138 1.433 2.913-.297z"
        fill="#fff"
        stroke={COLORS.secondary.darkBlue}
      />
      <path fill="#fff" d="M8.708 16.248l-.218-2.144-8.015.856.217 2.144z" />
    </svg>
  )
}
